import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_199: DocMigration = {
  maxSchemaVersion: "0.0.199",
  description: "Removes undefined values from settings",
  apply(json: any) {
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type !== "COLUMN_CATALOG_SETTINGS") {
        continue;
      }
      const columnTable = setting["columnTable"];
      if (!columnTable) {
        continue;
      }
      for (const columnId in columnTable) {
        const column = columnTable[columnId];
        if (column === undefined) {
          delete columnTable[columnId];
        }
      }
    }
    return json;
  },
};

export default migration_0_0_199;
